export class ProtocolSpecificRequirements {
  constructor(
    public contractRequired: Boolean,
    public trainingRequired: Boolean,
    public credentialsRequired: Boolean
  ) {}
}
